<script setup>
const props = defineProps({
  type: { type: String, required: true, validator: (v) => ['bingo', 'lost'].includes(v) },
  winTitle: { type: String, default: 'JIJ HEBT BINGO!' },
  winMessage: {
    type: String,
    default:
      "Hou je telefoon dan bij de hand, want de computer kiest er een winnaar uit en die bellen we op. Bellen ze jou? Neem dan op en roep luid 'BINGO'!",
  },
  loseTitle: { type: String, default: 'PROBEER HET MORGEN OPNIEUW!' },
  loseMessage: {
    type: String,
    default:
      'Helaas, vandaag zat je niet bij de gelukkige. Maar morgen opnieuw een kans, genereer nu al je bingokaart en speel morgen terug mee!',
  },
  hasNextRound: { type: Boolean, default: false },
})

defineEmits(['new-card'])
</script>

<template>
  <div class="game-overlay">
    <div class="overlay-card">
      <template v-if="type === 'bingo'">
        <div class="overlay-emoji">&#127881;</div>
        <h2 class="overlay-title">{{ props.winTitle }}</h2>
        <p class="overlay-text">{{ props.winMessage }}</p>
      </template>
      <template v-else>
        <div class="overlay-emoji">&#128546;</div>
        <h2 class="overlay-title">{{ props.loseTitle }}</h2>
        <p class="overlay-text">{{ props.loseMessage }}</p>
        <button v-if="props.hasNextRound" class="cta-button" @click="$emit('new-card')">MIJN BINGOKAART</button>
      </template>
    </div>
  </div>
</template>

<style scoped>
.game-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 24px;
}

.overlay-card {
  background: var(--bingo-gradient-ui);
  border-radius: 16px;
  padding: 40px 32px;
  text-align: center;
  max-width: 360px;
  width: 100%;
}

.overlay-emoji {
  font-size: 3rem;
  margin-bottom: 8px;
}

.overlay-title {
  font-family: var(--bingo-font-heading);
  text-transform: uppercase;
  color: white;
  font-size: 1.6rem;
  margin: 0 0 16px;
}

.overlay-text {
  font-family: var(--bingo-font-body);
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0 0 24px;
}

.cta-button {
  font-family: var(--bingo-font-heading);
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  color: var(--bingo-cta-text);
  background: white;
  border: none;
  border-radius: 24px;
  padding: 12px 32px;
  cursor: pointer;
  letter-spacing: 0.5px;
  transition: transform 0.15s ease;
}

.cta-button:hover {
  transform: scale(1.03);
}
</style>
